<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="1200px"
    @keydown.esc="dialog = false"
  >
    <v-card>
      <v-card-title v-if="data.control_no">
        Control No.: {{ data.control_no ? data.control_no.toUpperCase() : "" }}
        <v-spacer></v-spacer>
        {{ route ? route.toUpperCase() : "" }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 600px;" class="pt-0">
        <v-data-table :headers="headers" :items="dataTicket" hide-actions>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <td class="text-xs-center">{{ props.item.ticket_no }}</td>
            <td class="text-xs-center">{{ props.item.or_no }}</td>
            <td class="text-xs-center">{{ props.item.time }}</td>
            <td class="text-xs-center">{{ props.item.from }}</td>
            <td class="text-xs-center">{{ props.item.to }}</td>
            <td class="text-xs-center">{{ props.item.amount }}</td>
            <!-- <td v-if="dialog_type == 'passenger'" class="text-xs-center">
              {{ props.item.passenger_type.toUpperCase() }}
            </td> -->
            <!-- <td class="text-xs-center">{{ props.item.transaction_type.toUpperCase() }}</td> -->
            <!-- <td class="text-xs-center">{{ props.item.status.toUpperCase() }}</td> -->
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="dialog = false">
          <v-icon color="cyan">close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog_type", "data", "dataTicket", "route"],
  methods: {
    async openDialog() {
      this.headers = [];

      this.header_filler.map((item) => {
        this.headers.push(item);
      });

      // if (this.dialog_type == "passenger") {
      //   this.headers.splice(7, 0, {
      //     text: "Passenger Type",
      //     sortable: false,
      //     align: "center",
      //     value: "passenger_type",
      //   });
      // }
      this.dialog = true;
    },
    cloaseDialog() {
      this.dialog = false;
    },
  },
  data() {
    return {
      dialogm1: "",
      dialog: false,
      header_filler: [
        {
          text: "#",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "Ticket No.",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "OR No.",
          align: "center",
          sortable: false,
          value: "or_no",
        },
        {
          text: "Time",
          sortable: false,
          align: "center",
          value: "time",
        },
        {
          text: "From",
          sortable: false,
          align: "center",
          value: "from",
        },
        { text: "To", sortable: false, align: "center", value: "to" },
        { text: "Amount", sortable: false, align: "center", value: "protein" },
        // {
        //   text: "Transaction Type",
        //   sortable: false,
        //   align: "center",
        //   value: "carbs",
        // },
        // {
        //   text: "Status",
        //   sortable: false,
        //   align: "center",
        //   value: "carbs",
        // },
      ],
      headers: [],
    };
  },
};
</script>
